import Tooltip from "@mui/material/Tooltip";
import {
  GridEditInputCell,
  GridEditSingleSelectCell,
  type GridRenderEditCellParams,
} from "@mui/x-data-grid";
import { useEffect, useRef } from "react";

interface EditInputCellWithTooltipProps extends GridRenderEditCellParams {
  dataTestId?: string;
  error?: string;
  editableColumnIndex?: number;
}

export function EditInputCellWithTooltip(props: EditInputCellWithTooltipProps) {
  const { dataTestId, error, editableColumnIndex, colDef, ...rest } = props;
  const editCellRef = useRef<HTMLSpanElement>(null);

  const isSingleSelect = colDef.type === "singleSelect";
  const EditComponent = isSingleSelect
    ? GridEditSingleSelectCell
    : GridEditInputCell;
  const editCell = (
    <span ref={editCellRef} style={{ width: "100%" }}>
      <EditComponent colDef={colDef} {...rest} />
    </span>
  );

  useEffect(() => {
    if (!dataTestId) {
      return;
    }

    const input = editCellRef.current?.querySelector(
      'input, textarea, [role="combobox"]',
    );
    input?.setAttribute("data-testid", dataTestId);
  }, [dataTestId]);

  if (!error) {
    return editCell;
  }

  const placement =
    editableColumnIndex !== undefined && editableColumnIndex % 2 === 1
      ? "top"
      : "bottom";

  return (
    <Tooltip
      open={!!error}
      title={error}
      color="error"
      placement={placement}
      key={error + placement}
      arrow
    >
      {editCell}
    </Tooltip>
  );
}

export function RenderEditCellWithTooltip(
  params: GridRenderEditCellParams & {
    dataTestId?: string;
    editableColumnIndex?: number;
  },
) {
  return <EditInputCellWithTooltip {...params} />;
}
